// extracted by mini-css-extract-plugin
export var capabilityVideo = "CapabilityVideo-module--capabilityVideo--e1277";
export var dark = "CapabilityVideo-module--dark--9f9ed";